// extracted by mini-css-extract-plugin
module.exports = {"buyXPayForYChip":"BuyXPayForYChip_buyXPayForYChip___odA4"};